import { isFileSizeExceeded } from '@previo/core'
import { $t } from '../i18n'
import { toast } from './toasts'

export const validateFilesSize = (files: File[], maxSizeMb: number): boolean => {
  if (files.some((file) => isFileSizeExceeded(file.size, maxSizeMb))) {
    toast.negative($t('Maximum file size is {size} MB', { size: maxSizeMb }))

    return false
  }

  return true
}
